
import {
   TImageField,
   TLinkField,
   TSitecoreProps,
   TStringField,
   WithSitecoreContextProps
  } from "../../../types/types";


export type TNewsLetterSubscriptionFields = {
    image?: TImageField;
    title?: TStringField;
    description?: TStringField;
    newsSubscriptionTitle?: TStringField;
    link?: TLinkField;
    isComponentUnreleased?: boolean;
    backgroundTheme: {
      fields: {
        Key: {
          value: string;
        }
      }
    }
};

export enum backgroundTheme {
  red = 'red',
  black = 'black'
};

export type TNewsLetterSubscriptionProps = WithSitecoreContextProps & TSitecoreProps<TNewsLetterSubscriptionFields>;
